import React, { useEffect, useState } from 'react';
import { accountAPI } from '../../../../api/client';
import { POPULAR_ZONES } from '../../../../lib/displayFormat';

let cache = null;

/** Time zone picker: the common ones first, then every IANA zone. `empty` adds a "use the default" choice. */
export default function TimezoneSelect({ value, onChange, empty, disabled, id }) {
  const [all, setAll] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    accountAPI.timezones().then((res) => { cache = res.data; setAll(res.data); }).catch(() => {});
  }, []);
  const popular = new Set(POPULAR_ZONES.map(([z]) => z));
  return (
    <select id={id} value={value || ''} disabled={disabled} onChange={(e) => onChange(e.target.value || null)}>
      {empty && <option value="">{empty}</option>}
      <optgroup label="Common">{POPULAR_ZONES.map(([z, label]) => <option key={z} value={z}>{label}</option>)}</optgroup>
      {all.length > 0 && <optgroup label="All time zones">{all.filter((z) => !popular.has(z)).map((z) => <option key={z} value={z}>{z.replace(/_/g, ' ')}</option>)}</optgroup>}
      {value && !popular.has(value) && !all.includes(value) && <option value={value}>{value}</option>}
    </select>
  );
}
